module.exports = __webpack_public_path__ + "img/gift4-01-c10-k2.57540b62.png";